import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import {
  addIntroOutro,
  deleteIntroOutro,
  loadIntroOutroData,
  replaceIntroOutro,
} from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'INTRO_OUTRO_ADD':
      return addIntroOutro(
        state,
        action.payload.type,
        action.payload.src,
        action.payload.fileName,
      );

    case 'INTRO_OUTRO_DELETE':
      return deleteIntroOutro(state, action.payload.type);

    case 'INTRO_OUTRO_LOAD':
      return loadIntroOutroData(
        state,
        action.payload.type,
        action.payload.src,
        action.payload.fileName,
      );

    case 'INTRO_OUTRO_REPLACE':
      return replaceIntroOutro(
        state,
        action.payload.type,
        action.payload.src,
        action.payload.fileName,
      );

    default:
      return state;
  }
}
